/**
 * Enum representing the possible status values for the ForgotPassword page.
 */
export enum ForgotPasswordStatus {
  /**
   * The initial status value.
   */
  INITIAL = 'INITIAL',
  /**
   * The status value indicating that an email has been sent for password reset.
   */
  EMAIL_SENT = 'EMAIL_SENT',
  /**
   * The status value indicating a forced retry (reload the page) for password reset.
   */
  FORCED_RETRY = 'FORCED_RETRY',
}

/**
 * Represents the state of password reset.
 */
export type ResetPasswordState = {
  /**
   * The status of users for password recovery.
   */
  usersTimeToNextTry: Record<string, number>;
};

/**
 * Represents the actions for password reset.
 */
export type ResetPasswordActions = {
  /**
   * Adds the time to next try timestamp for the user
   * @param {string} username - The username of the user to add.
   * @param {number} timeToNextTry - The time to the next retry in milliseconds.
   * @returns {void}
   */
  setUserNextTry: (username: string, timeToNextTry?: number) => void;
};

/**
 * Represents the store for password reset, combining the state and actions.
 */
export type ResetPasswordStore = ResetPasswordState & ResetPasswordActions;
